import { listActivityOptions } from "@payezy/api-client/public/query";
import { Badge, Card, EmptyState, PageHeader, Spinner, Table, TD, TH, THead, TR, formatDate, humanize } from "@payezy/ui";
import { useQuery } from "@tanstack/react-query";
import { useOrg } from "../lib/org";

export function ActivityPage() {
  const org = useOrg();
  const q = useQuery(listActivityOptions({ path: { orgId: org.org_id }, query: { limit: 100 } }));
  return (
    <>
      <PageHeader title="Activity" description="A complete record of changes in this account, including actions taken by Payezy support on your behalf." />
      <Card>
        {q.isLoading ? (
          <div className="flex justify-center p-8"><Spinner /></div>
        ) : q.data?.items.length ? (
          <Table>
            <THead><tr><TH>When</TH><TH>Who</TH><TH>Action</TH><TH>Details</TH></tr></THead>
            <tbody>
              {q.data.items.map((e) => (
                <TR key={e.id}>
                  <TD className="whitespace-nowrap text-ink-500">{formatDate(e.occurred_at, true)}</TD>
                  <TD>
                    {e.actor_name}
                    {e.on_behalf && <Badge tone="warning" className="ml-2">On your behalf</Badge>}
                  </TD>
                  <TD>{humanize(e.action)}</TD>
                  <TD className="text-ink-500">{e.reason || humanize(e.resource_type)}</TD>
                </TR>
              ))}
            </tbody>
          </Table>
        ) : (
          <EmptyState title="No activity yet" />
        )}
      </Card>
    </>
  );
}
